// Nimba funnel tracking helper.
// Pushes into dataLayer when present and logs in local preview.
(function() {
  'use strict';

  var isPreviewEnv =
    location.hostname === 'localhost' ||
    location.hostname === '127.0.0.1' ||
    location.protocol === 'file:';
  var STORAGE_KEY = 'nimba_track_events';
  var MAX_EVENTS = 300;

  function readProps(el) {
    if (!el) return {};
    const raw = el.getAttribute('data-track-props');
    if (!raw) return {};
    try {
      return JSON.parse(raw);
    } catch (err) {
      console.warn('[ntrack] Invalid data-track-props JSON:', raw, err);
      return {};
    }
  }

  function storePreviewEvent(payload) {
    if (!isPreviewEnv || !window.localStorage) return;
    try {
      var events = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      events.push(payload);
      if (events.length > MAX_EVENTS) {
        events = events.slice(events.length - MAX_EVENTS);
      }
      localStorage.setItem(STORAGE_KEY, JSON.stringify(events));
    } catch (err) {
      console.warn('[ntrack] Failed to persist preview event:', err);
    }
  }

  // ---- Production collector ----
  // Set NIMBA_COLLECTOR_URL before this script loads to override.
  // Deploy-time value should match the QC platform origin that has
  // the storefront domain in WEBSITE_EVENTS_ALLOWED_ORIGINS.
  // Known production domains: qc.sheaitaint.com, qc.nimbafoods.xyz
  var COLLECTOR_URL = window.NIMBA_COLLECTOR_URL || 'https://qc.sheaitaint.com';
  var COLLECTOR_ENDPOINT = COLLECTOR_URL + '/api/website-events';

  function sendToCollector(payload) {
    if (isPreviewEnv) return;
    var body = JSON.stringify(payload);
    try {
      if (navigator.sendBeacon) {
        var sent = navigator.sendBeacon(
          COLLECTOR_ENDPOINT,
          new Blob([body], { type: 'application/json' })
        );
        if (sent) return;
      }
      fetch(COLLECTOR_ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: body,
        keepalive: true
      }).catch(function() { /* fire-and-forget */ });
    } catch (e) { /* never break the page */ }
  }

  window.ntrack = function(eventName, props) {
    if (!eventName) return;
    const payload = Object.assign(
      {
        event: eventName,
        ts: new Date().toISOString(),
        path: location.pathname
      },
      props || {}
    );
    if (Array.isArray(window.dataLayer)) {
      window.dataLayer.push(payload);
    }
    storePreviewEvent(payload);
    if (isPreviewEnv) {
      console.log('[ntrack]', eventName, props || {});
    }
    sendToCollector({
      event: payload.event,
      ts: payload.ts,
      path: payload.path,
      page_url: location.href,
      referrer: document.referrer || null,
      props: props || null
    });
  };

  window.ntrackDebug = {
    all: function() {
      try {
        return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      } catch (err) {
        console.warn('[ntrack] Failed to read preview events:', err);
        return [];
      }
    },
    clear: function() {
      if (!window.localStorage) return;
      localStorage.removeItem(STORAGE_KEY);
      console.log('[ntrack] Cleared preview event log');
    },
    exportJson: function() {
      return JSON.stringify(this.all(), null, 2);
    },
    download: function(filename) {
      var name = filename || 'nimba-track-events.json';
      var blob = new Blob([this.exportJson()], { type: 'application/json' });
      var url = URL.createObjectURL(blob);
      var link = document.createElement('a');
      link.href = url;
      link.download = name;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
      console.log('[ntrack] Downloaded preview event log as', name);
    }
  };

  document.addEventListener('click', function(event) {
    const el = event.target.closest('[data-track-event]');
    if (!el) return;
    window.ntrack(el.getAttribute('data-track-event'), readProps(el));
  });

  document.addEventListener('submit', function(event) {
    const form = event.target.closest('[data-track-submit]');
    if (!form) return;
    window.ntrack(form.getAttribute('data-track-submit'), readProps(form));
  });
})();
